import { Link } from "react-router-dom";
import { Package, Pill, ChevronRight, Info } from "lucide-react";

export default function SanitarioDeblistering() {
  return (
    <div className="max-w-2xl mx-auto space-y-4">
      <div>
        <h1 className="text-xl font-bold text-slate-900">Deblistering e Terapie</h1>
        <p className="text-sm text-slate-500 mt-1">
          Controlli operativi su terapie e farmaci dal tablet, senza entrare nel gestionale
          completo.
        </p>
      </div>

      <div className="rounded-2xl border border-sky-200 bg-sky-50/60 p-4 flex gap-3">
        <Info className="w-5 h-5 text-sky-600 shrink-0 mt-0.5" />
        <p className="text-sm text-slate-700 leading-relaxed">
          La preparazione blister e gli ordini farmacia restano nel Portale Farmacia / modulo
          Deblistering del gestionale. Qui l&apos;operatore gestisce terapie attive,
          somministrazioni e alert sul posto di cura.
        </p>
      </div>

      <div className="grid gap-3">
        <Link
          to="/sanitario/terapie"
          className="flex items-center gap-3 rounded-2xl border border-slate-200 bg-white p-4 shadow-sm hover:shadow-md transition"
        >
          <div className="w-11 h-11 rounded-xl bg-sky-100 flex items-center justify-center">
            <Pill className="w-5 h-5 text-sky-700" />
          </div>
          <div className="flex-1">
            <p className="font-semibold text-slate-800">Alert e somministrazioni</p>
            <p className="text-xs text-slate-500">Farmaci in scadenza, mancanti, da firmare</p>
          </div>
          <ChevronRight className="w-4 h-4 text-slate-400" />
        </Link>
        <Link
          to="/sanitario/scheda"
          className="flex items-center gap-3 rounded-2xl border border-slate-200 bg-white p-4 shadow-sm hover:shadow-md transition"
        >
          <div className="w-11 h-11 rounded-xl bg-violet-100 flex items-center justify-center">
            <Package className="w-5 h-5 text-violet-700" />
          </div>
          <div className="flex-1">
            <p className="font-semibold text-slate-800">Terapie in scheda ospite</p>
            <p className="text-xs text-slate-500">Elenco terapie attive e storico somministrazioni</p>
          </div>
          <ChevronRight className="w-4 h-4 text-slate-400" />
        </Link>
      </div>
    </div>
  );
}
